/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import {
  FaChevronRight, FaSearch, FaAngleDown, FaArrowUp, FaTimesCircle,
} from 'react-icons/fa';
import { connect } from 'react-redux';
import io from 'socket.io-client';

import TabsComponent from '../../components/Orders/Tabs';
import Filter from '../../components/Filter';
import CancelOrderModal from '../../components/Modal/Orders/Cancel';
import All from './All';
import Pending from './Pending';
import Confirmed from './Confirmed';
import Shipment from './Shipment';
import Complete from './Complete';
import Cancelled from './Cancelled';
import Footer from '../../components/Footer';

import {
  Breadcrumb, Label, Input, Content,
} from './styles';
import { Wrapper, ScrollTop } from '../../assets/styles';

class Orders extends Component {
  state = {
    tabIndex: 0,
    tabsMap: new Map([[0, true]]),
    tabs: false,
    searchValue: '',
    searchFocus: false,
    searchBy: '',
    itemsCount: 0,
    filter: false,
    filterValue: {
      type: 'item',
      selected: null,
      value: 'Mais recentes',
    },
    cancelOrderModal: false,
    scrolling: false,
  }

  componentDidMount() {
    this.registerToSocket();

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.hideFilter);
    document.removeEventListener('click', this.hideTabs);
    window.removeEventListener('scroll', this.handleScroll);
  }

  registerToSocket = () => {
    const socket = io(process.env.REACT_APP_WEB_SOCKET_ENDPOINT);

    socket.on('NEW_ORDER', (storeId) => {
      if (storeId === this.props.store.id) {
        if (this.state.tabIndex === 0) this.allOrders.refetchQueries();
        else if (this.state.tabIndex === 1) this.pendingOrders.refetchQueries();
      }
    });

    socket.on('ORDER_STATUS_UPDATED', (storeId) => {
      if (storeId === this.props.store.id) {
        if (this.state.tabIndex === 0) this.allOrders.refetchQueries();
        else if (this.state.tabIndex === 1) this.pendingOrders.refetchQueries();
        else if (this.state.tabIndex === 2) this.confirmedOrders.refetchQueries();
        else if (this.state.tabIndex === 3) this.shipmentOrders.refetchQueries();
        else if (this.state.tabIndex === 4) this.completeOrders.refetchQueries();
        else if (this.state.tabIndex === 5) this.cancelledOrders.refetchQueries();
      }
    });
  }

  handleScroll = () => {
    if (window.scrollY < 300 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
    } else if (window.scrollY > 300 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
    }
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  handleTabs = (index) => {
    this.setState(() => {
      const tabIndex = index;
      const tabsMap = new Map();
      tabsMap.set(index, !tabsMap.get(index));
      return { tabIndex, tabsMap };
    });
  }

  handleSearch = (e) => {
    e.preventDefault();

    const { searchValue } = this.state;

    if (searchValue.length !== 0) {
      this.setState({ searchBy: searchValue });

      if (this.state.tabIndex === 0) this.allOrders.handleFilter();
      else if (this.state.tabIndex === 1) this.pendingOrders.handleFilter();
      else if (this.state.tabIndex === 2) this.confirmedOrders.handleFilter();
      else if (this.state.tabIndex === 3) this.shipmentOrders.handleFilter();
      else if (this.state.tabIndex === 4) this.completeOrders.handleFilter();
      else if (this.state.tabIndex === 5) this.cancelledOrders.handleFilter();
    }
  }

  resetSearch = () => {
    this.setState({
      searchValue: '',
      searchBy: '',
    });

    if (this.state.tabIndex === 0) this.allOrders.handleFilter();
    else if (this.state.tabIndex === 1) this.pendingOrders.handleFilter();
    else if (this.state.tabIndex === 2) this.confirmedOrders.handleFilter();
    else if (this.state.tabIndex === 3) this.shipmentOrders.handleFilter();
    else if (this.state.tabIndex === 4) this.completeOrders.handleFilter();
    else if (this.state.tabIndex === 5) this.cancelledOrders.handleFilter();
  }

  handleFilter = (value) => {
    this.setState({ filterValue: value });

    if (this.state.tabIndex === 0) this.allOrders.handleFilter();
    else if (this.state.tabIndex === 1) this.pendingOrders.handleFilter();
    else if (this.state.tabIndex === 2) this.confirmedOrders.handleFilter();
    else if (this.state.tabIndex === 3) this.shipmentOrders.handleFilter();
    else if (this.state.tabIndex === 4) this.completeOrders.handleFilter();
    else if (this.state.tabIndex === 5) this.cancelledOrders.handleFilter();

    this.setState({ filter: false }, () => {
      document.removeEventListener('click', this.hideFilter);
    });
  }

  handleItemsCount = (qtd) => {
    this.setState({ itemsCount: qtd });
  }

  showTabs = () => {
    this.setState({ tabs: true }, () => {
      document.addEventListener('click', this.hideTabs);
    });
  }

  hideTabs = () => {
    this.setState({ tabs: false }, () => {
      document.removeEventListener('click', this.hideTabs);
    });
  }

  showFilter = async () => {
    await this.setState({ filter: true }, () => {
      document.addEventListener('click', this.hideFilter);
    });

    this.filterComponent.onMount(this.state.filterValue);
  }

  hideFilter = (e) => {
    if (!e.srcElement.offsetParent || e.srcElement.offsetParent.id !== 'filter') {
      this.setState({ filter: false }, () => {
        document.removeEventListener('click', this.hideFilter);
      });
    }
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSelectChange = (field, value) => {
    this.setState({ [field]: value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  openCancelOrderModal = (wirecardId, orderId, storeOrderId, userId) => {
    this.cancelOrderModal.openCancelOrderModal(wirecardId, orderId, storeOrderId, userId);

    this.setState({ cancelOrderModal: true });
  };

  closeCancelOrderModal = () => {
    if (this.state.tabIndex === 0) this.allOrders.refetchQueries();
    else if (this.state.tabIndex === 1) this.pendingOrders.refetchQueries();
    else if (this.state.tabIndex === 2) this.confirmedOrders.refetchQueries();
    else if (this.state.tabIndex === 3) this.shipmentOrders.refetchQueries();
    else if (this.state.tabIndex === 4) this.completeOrders.refetchQueries();
    else if (this.state.tabIndex === 5) this.cancelledOrders.refetchQueries();

    this.setState({ cancelOrderModal: false });
  };

  render() {
    const {
      tabIndex,
      tabs,
      itemsCount,
      filter,
      filterValue,
      searchFocus,
    } = this.state;

    return (
      <div style={{ position: 'absolute', width: '100%' }}>
        <MetaTags>
          <title>Pedidos - Portal da Loja - Reforma Fácil</title>
          <meta name="robots" content="noindex" />
        </MetaTags>
        <Breadcrumb>
          <div className="container">
            <div className="row">
              <h2>Pedidos</h2>
              <FaChevronRight className="fa fa-chevron-right" />
              <h2 className="bold">Resumo</h2>
            </div>
            <div className="row">
              <form onSubmit={this.handleSearch}>
                <Label onFocusInput={searchFocus}>
                  <FaSearch className="fa fa-search" />
                  <Input
                    type="text"
                    name="searchValue"
                    placeholder="Nº do pedido"
                    value={this.state.searchValue}
                    onChange={this.handleInputChange}
                    onFocus={() => this.onFocus('searchFocus')}
                    onBlur={() => this.onBlur('searchFocus')}
                  />
                </Label>
              </form>
            </div>
          </div>
        </Breadcrumb>
        <Wrapper>
          {filter && (
            <Filter
              ref={(ref) => { this.filterComponent = ref; }}
              handleFilter={this.handleFilter}
              orderPadding={this.state.searchBy.length !== 0}
            />
          )}
          <Content filter={filter}>
            <Tabs className="tabs-container" defaultIndex={0} onSelect={index => this.handleTabs(index)}>
              {this.state.searchBy.length !== 0 && (
                <div className="active-filters">
                  <span>Filtros ativos:</span>
                  <div className="item">
                    <FaTimesCircle className="fa fa-times-circle" onClick={this.resetSearch} />
                    <span>{`Nº do pedido: ${this.state.searchBy}`}</span>
                  </div>
                </div>
              )}
              <div className="controls">
                <TabList className="tabs tabs-lg">
                  <Tab><span>Todos os pedidos</span></Tab>
                  <Tab><span>Pendentes</span></Tab>
                  <Tab><span>Confirmados</span></Tab>
                  <Tab><span>Saiu para entrega</span></Tab>
                  <Tab><span>Entregues</span></Tab>
                  <Tab><span>Cancelados</span></Tab>
                </TabList>
                <div className="tabs-sm" onClick={this.showTabs}>
                  {tabIndex === 0 && <span>Todos os pedidos</span>}
                  {tabIndex === 1 && <span>Pendentes</span>}
                  {tabIndex === 2 && <span>Confirmados</span>}
                  {tabIndex === 3 && <span>Saiu para entrega</span>}
                  {tabIndex === 4 && <span>Entregues</span>}
                  {tabIndex === 5 && <span>Cancelados</span>}
                  <FaAngleDown className="fa fa-angle-down" />
                </div>
                {tabs && <TabsComponent selected={this.state.tabsMap} />}
                <div className="list-controls">
                  <div className="items-found">
                    <span>{`${itemsCount || 0} item(s)`}</span>
                  </div>
                  <div className="filters" onClick={this.showFilter}>
                    <span className="text">{filterValue.value}</span>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span className="separator" />
                      <FaAngleDown className="fa fa-angle-down" />
                    </div>
                  </div>
                </div>
              </div>
              <TabPanel>
                <All
                  ref={(el) => { if (el) this.allOrders = el.getWrappedInstance(); }}
                  openCancelOrderModal={this.openCancelOrderModal}
                  closeCancelOrderModal={this.closeCancelOrderModal}
                  store={this.props.store}
                  handleItemsCount={this.handleItemsCount}
                  filterValue={this.state.filterValue}
                  searchBy={this.state.searchBy}
                />
              </TabPanel>
              <TabPanel>
                <Pending
                  ref={(el) => { if (el) this.pendingOrders = el.getWrappedInstance(); }}
                  openCancelOrderModal={this.openCancelOrderModal}
                  closeCancelOrderModal={this.closeCancelOrderModal}
                  store={this.props.store}
                  handleItemsCount={this.handleItemsCount}
                  filterValue={this.state.filterValue}
                  searchBy={this.state.searchBy}
                />
              </TabPanel>
              <TabPanel>
                <Confirmed
                  ref={(el) => { if (el) this.confirmedOrders = el.getWrappedInstance(); }}
                  openCancelOrderModal={this.openCancelOrderModal}
                  closeCancelOrderModal={this.closeCancelOrderModal}
                  store={this.props.store}
                  handleItemsCount={this.handleItemsCount}
                  filterValue={this.state.filterValue}
                  searchBy={this.state.searchBy}
                />
              </TabPanel>
              <TabPanel>
                <Shipment
                  ref={(el) => { if (el) this.shipmentOrders = el.getWrappedInstance(); }}
                  openCancelOrderModal={this.openCancelOrderModal}
                  closeCancelOrderModal={this.closeCancelOrderModal}
                  store={this.props.store}
                  handleItemsCount={this.handleItemsCount}
                  filterValue={this.state.filterValue}
                  searchBy={this.state.searchBy}
                />
              </TabPanel>
              <TabPanel>
                <Complete
                  ref={(el) => { if (el) this.completeOrders = el.getWrappedInstance(); }}
                  store={this.props.store}
                  handleItemsCount={this.handleItemsCount}
                  filterValue={this.state.filterValue}
                  searchBy={this.state.searchBy}
                />
              </TabPanel>
              <TabPanel>
                <Cancelled
                  ref={(el) => { if (el) this.cancelledOrders = el.getWrappedInstance(); }}
                  store={this.props.store}
                  handleItemsCount={this.handleItemsCount}
                  filterValue={this.state.filterValue}
                  searchBy={this.state.searchBy}
                />
              </TabPanel>
            </Tabs>
            <Footer marginBottom />
          </Content>
        </Wrapper>
        {this.state.scrolling && (
          <ScrollTop onClick={this.scrollToTop}>
            <FaArrowUp className="fa fa-arrow-up" />
            <span>Topo</span>
          </ScrollTop>
        )}
        <CancelOrderModal
          ref={(el) => { if (el) this.cancelOrderModal = el.getWrappedInstance(); }}
          open={this.state.cancelOrderModal}
          close={this.closeCancelOrderModal}
          store={this.props.store}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state.store,
});

export default connect(mapStateToProps, null)(Orders);
